export default "__VITE_ASSET__TNVsRhXX__"